import { Region } from 'libs/shared/components/src/lib/weighted-location-selection/interfaces';

export const SUMMARY_VIEW_ID = 'SUMMARY_VIEW';

export const SUMMARY_VIEW: Region = {
  id: SUMMARY_VIEW_ID,
  text: 'SUMMARY VIEW',
};
